import { exportExcelMain } from '../../utils/export-excel';
import { DownloadIcon } from 'src/components/ui-icons/upload';
import { GroupRequirement, Department } from '../../types/data';
import { TooltipItem } from "src/utils/Tooltip";

type ExportExcelMainProps = {
  data: GroupRequirement[];
  departments: Department[];
  params: {
    column: { [key: string]: string | number }
  };
}

function ExportExcelMain({ data, departments, params }: ExportExcelMainProps) {
  return (
    <TooltipItem position="top" tooltipsText={'Экспорт в Excel'}>
      <button
        className="rounded-md bg-white p-4 shadow-md h-full"
        type="button"
        onClick={() => exportExcelMain(data, departments, params)}>
        <DownloadIcon />
      </button>
    </TooltipItem>
  )
}

export default ExportExcelMain;
